<template>
    <div>
    <div class="bg-darker lightest mt-2 py-2 px-4" v-if="getReservationCalculations && !noTicketsSelected">
            <div>
                <div class="d-flex flex-row justify-content-between align-items-baseline">
                    <span>Total</span>
                    <span v-if="getIsLoadingCalculations" class="font-weight-600 fs-largest"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else class="font-weight-600 fs-largest">{{formatPrice(getReservationCalculations.grandTotal)}} €</span>
                </div>

                <div class="d-flex flex-row justify-content-between align-items-baseline" v-if="true">
                    <span v-if="getReservationCalculations.entityCommissionToComponentType == 1">Discount ({{getReservationCalculations.entityCommissionToComponentValue}}%)</span>
                    <span v-if="getReservationCalculations.entityCommissionToComponentType == 0">Discount ({{getReservationCalculations.entityCommissionToComponentValue}}€)</span>

                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{ formatPrice(getReservationCalculations.totalDiscounts) }} €</span>
                </div>

                <div class="d-flex flex-row justify-content-between align-items-baseline">
                    <span>
                        <span>Deposit</span>
                        <span v-if="getReservationCalculations.depositPaymentType == 2 && getReservationCalculations.depositType == 1"> ({{getReservationCalculations.depositValue}}%)</span>
                        <span v-if="getReservationCalculations.depositPaymentType == 1"> (Full amount)</span>
                    </span>

                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations.grandTotalDepositValueRequired)}} €</span>
                </div>
                
                <div class="d-flex flex-row justify-content-between align-items-baseline">
                    <span>
                        <span>Comissions (total)</span>
                    </span>

                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations.grandTotalCommission)}} €</span>
                </div>

                <div class="d-flex flex-row justify-content-between align-items-baseline mt-1 medium" v-for="commissionType in comissionTypes" v-if="commissionType.active">
                    <span class="d-flex align-items-center ml-2">
                        {{commissionType.label}} 
                        <span class="px-1" v-if="!isEditingCommissions[commissionType.type.toLowerCase()]">
                            ({{localReservation.currentChannelCommission[commissionType.type.toLowerCase() + 'Value']}}{{localReservation.currentChannelCommission[commissionType.type.toLowerCase() + 'ValueType'] == 1? '%':'€'}})
                        </span> 
                        
                        <span class="d-flex px-1 align-items-center" v-if="isEditingCommissions[commissionType.type.toLowerCase()]">
                            <input type="number" class="glued-right px-2 py-0 text-center border-medium" style="width: 40px;" v-model.number="localReservation.currentChannelCommission[commissionType.type.toLowerCase() + 'Value']" @input="overrideCommissionChanged($event, commissionType.type)">
                            <div class="glued-left w-25 py-0 px-1 pointer dark border-medium" style="width: auto !important;" @click="switchCommissionType(commissionType.type)" v-if="localReservation.currentChannelCommission[commissionType.type.toLowerCase() + 'ValueType'] == 1">%</div>
                            <div class="glued-left w-25 py-0 px-1 pointer dark border-medium" style="width: auto !important;" @click="switchCommissionType(commissionType.type)" v-if="localReservation.currentChannelCommission[commissionType.type.toLowerCase() + 'ValueType'] == 0">€</div>
                            <button :disabled="noTicketsSelected" class="btn secondary small fs-small mx-1" v-if="localReservation.currentChannelCommission['isToOverwrite' + commissionType.type]" @click="updateCommissions(commissionType)">Apply</button>
                        </span>

                        <span v-else>
                            <button v-if="!localReservation.attachPromocode && (localReservation.attachPromocodeType === 0 || !localReservation.attachPromocodeType)" :disabled="noTicketsSelected" class="btn secondary small fs-small mx-1" @click="editingCommissionToogle(commissionType.type)">{{ isEditingCommissions[commissionType.type.toLowerCase()] ? 'Use default' : 'Edit'}}</button>
                        </span>
                    </span>

                    <span v-if="getIsLoadingCalculations"><loader size="small" opacity="0.2"></loader></span>
                    <span v-else>{{formatPrice(getReservationCalculations['total' + commissionType.type + 'CommissionToEntityGrossprice'])}} €</span>
                </div>
            </div>
        </div>

        <div class="d-flex">
            <button
                class="radius-normal border-dark mt-2 font-weight-600 lightest text-center flex-fill text-nowrap fs-larger py-2 pointer btn blue"
                :disabled="shouldDisableActions"
                @click="openReservationPayIn()">
                    Payment
            </button>

            <button
                v-if="enabledStatusStripeIntegration"
                class="radius-normal border-dark mt-2 font-weight-600 lightest text-center flex-fill text-nowrap fs-larger py-2 pointer ml-2 btn blue"
                :disabled="shouldDisableActions"
                @click="openReservationLinkIn()">Payment Link
            </button>

            <button
                class="radius-normal border-dark mt-2 font-weight-600 lightest text-center flex-fill text-nowrap fs-larger py-2 pointer ml-2 btn ok"
                :disabled="shouldDisableActions"
                @click="saveReservation(false)">
                <loader v-if="isSaving" size="small" />
                <template v-else>Save</template>
            </button>

            <button
                class="radius-normal border-dark mt-2 font-weight-600 lightest text-center flex-fill text-nowrap fs-larger py-2 pointer ml-2 btn ok"
                :disabled="shouldDisableActions"
                @click="saveReservation(true)">
                <loader v-if="isSaving" size="small" />
                <template v-else>Save & Print</template>
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required, email, minLength } from 'vuelidate/lib/validators'
import Loader from '@/tools/loaders/loader1'
import { eventHub } from "@/main"
import { reservationsMixin } from '@/mixins/reservations'

export default {
    data() {
        return {
            localReservation: {},
            clickedSave: false,
            clickedSaveAndPrint: false,
            comissionTypes:[
                {
                    type: 'Product',
                    label: 'Ticket',
                    active: true
                },
                {
                    type: 'Component',
                    label: 'Extras',
                    active: true
                },
                {
                    type: 'Transport',
                    label: 'Transport',
                    active: false
                },
            ],
            isEditingCommissions: {},
            genderPriceDependencies: false,
            promocodeIsValid: true,
            isSaving: false
        }
    },
    validations: {
        reservation:{
            customer: {
                name: {
                    required
                },
                country: {
                    required
                },
                email: {
                    email,
                }
            }
        }
    },
    props: {
        reservation: {
            type: Object
        },
        noTicketsSelected: {
            type: Boolean,
            default: false
        },
		sideBarOriginAndSegmentIsReadyToSubmit: {
			type: Boolean,
			default: false
		}
    },
    watch: {
        'getReservationCalculations': {
            handler(newVal) {
                this.localReservation.currentChannelCommission = newVal.currentChannelCommission;
            },
        }
    },
    created() {
        this.localReservation = this.reservation;

        eventHub.$on("genderPriceDeps", (flag) => {
			this.genderPriceDependencies = flag;
		});

        eventHub.$on("promocodeValidation", (flag) => {
			this.promocodeIsValid = flag;
		});

        eventHub.$on('createReservationBeforePayIn', this.handleReservationCreationBeforePayIn);
        
    },
    beforeDestroy() {
		eventHub.$off("genderPriceDeps");
		eventHub.$off("promocodeValidation");
        eventHub.$off('createReservationBeforePayIn', this.handleReservationCreationBeforePayIn)
	},
    mixins: [
        reservationsMixin
    ],
    computed: {
        ...mapGetters([
            'account',
            'getReservationCalculations',
            'getIsLoadingCalculations',
            'getIsAddingReservation',
            'getIsLoadingSupplierIntegrations',
            'getSingleIntegration',
            'getAllIntegrations',
            'getShowInvoiceOption',
            'getIsReservationCreationPayInPartialFullAmount'
        ]),
        shouldDisableActions() {
            return !!(
                this.noTicketsSelected ||
                this.$v.$invalid ||
                this.getIsAddingReservation ||
                this.getIsLoadingCalculations ||
                !this.sideBarOriginAndSegmentIsReadyToSubmit ||
                this.genderPriceDependencies ||
                !this.promocodeIsValid ||
                (this.reservation && this.reservation.customer && this.reservation.customer.phone && this.reservation.customer.isInvalid) ||
                (this.reservation && 
                    this.reservation.event && 
                    this.reservation.event.bookingQuestionIsMandatory && 
                    this.reservation.event.bookingQuestionIsActive && 
                    !this.reservation.bookingAnswer)
            );
        },
        hasInvoiceSystem() {
            return this.getShowInvoiceOption;
        },
        costTotal() {
            let total = 0;
            let totalWithVat = 0;

            // Ticket cost
            for (let personType of this.localReservation.event.eventGenderPrices) {
                total += personType.value * personType.quantityToBook;
                totalWithVat += personType.valueCalculated * personType.quantityToBook;
            }

            // Extras
            for (let extra of this.localReservation.product.extras) {
                // Both now have taxes, without taxes needs to be worked on
                total += extra.item.grossprice * extra.quantity;
                totalWithVat += extra.item.priceIncludeTaxes * extra.quantity;
            }

            return {
                total: total,
                totalWithVat: totalWithVat
            }
        },
        stripeIntegration() {
            if (this.getAllIntegrations.length > 0 && this.getIsLoadingSupplierIntegrations == false) {
                return this.getSingleIntegration(101);
            } else {
                return false;
            }
        },
        enabledStatusStripeIntegration() {
            if (this.stripeIntegration) {
                return this.stripeIntegration.integrationStatus == 1;
            } else {
                return false;
            }
        },
        agentCommissionPercent(){
            if (this.localReservation.billing.agentCommision) {
                let commissionPercet = this.selectedAgentComissions.defaultCommission;

                this.selectedAgentComissions.commissionRelations.find(commissionRelation => {
                    if(commissionRelation.productId == this.localReservation.product.id){
                        commissionPercet = commissionRelation.commissionValue;
                    }
                })

                return commissionPercet;
            } else {
                return null;
            }
        },
        discountValue() {
            if (this.localReservation.billing.discountValue) {
                if (this.localReservation.billing.discountType == 1) {
                    return Number(this.costTotal.totalWithVat) * (Number(this.localReservation.billing.discountValue) / 100);
                } else {
                    return this.localReservation.billing.discountValue;
                }
            } else {
                return false;
            }
        },
        costTotalDiscounted() {
            if (this.localReservation.billing.discountValue) {
                this.localReservation.helper.totalToPay = this.costTotal.totalWithVat - this.discountValue;
                
                return {
                    total: this.costTotal.total - this.discountValue,
                    totalWithVat: this.costTotal.totalWithVat - this.discountValue
                }
            } else {
                this.localReservation.helper.totalToPay = this.costTotal.totalWithVat;
                
                return this.costTotal;
            }
        },
    },
    methods: {
        ...mapActions([
            'openModal',
            'setReservationCreation',
            'createNewReservation',
            'setReservationCalculations',
            'setReservation',
            'printInvoice',
            'addFloatingNotification',
            'setReservation',
        ]),
        async handleReservationCreationBeforePayIn(resolve) {
        
            this.saveLastCustomerDetails()

            if (this.getIsAddingReservation) {
                this.$toasted.info('Already creating reservation, please wait.')

                resolve({ ok: false })
                return
            }

            try {
                const response = await this.createNewReservation({ reservation: this.localReservation });

                if (response === 'invalid') {
                    resolve({ ok: false })
                    return
                }

                if (response.status !== 200) {
                    resolve({ ok: false })
                    return
                }

                resolve({
                    ok: true,
                    bookingId: response.data.id,
                    reservation: response.data
                })

            } catch (e) {
                resolve({ ok: false })
            }
        },
        openReservationPayIn() {
            // Not editing, we are creating new one
            this.setReservationCreation();
            this.openModal('ReservationPayIn');
        },
        openReservationLinkIn() {
            this.setReservationCreation(); 
            this.openModal('ReservationLinkIn');
        },
        saveReservation(printTicket) {
            if (this.isSaving) return;
            this.isSaving = true;
            this.saveLastCustomerDetails();

            if (this.getIsAddingReservation) {
                this.$toasted.info('Already creating reservation, please wait.');
                
                return false;
            }

            if (printTicket) {
                this.clickedSaveAndPrint = true;
            } else {
                this.clickedSave = true;
            }

            let vm = this;

            // Check if agent and there is a deposit, if so adds it as a payment
            if (this.localReservation.creatorAgent && this.getReservationCalculations.grandTotalDepositValueRequired > 0 && !this.getIsReservationCreationPayInPartialFullAmount) {
                this.applyDeposit();
            }

            this.createNewReservation({supplierId: this.account.supplierId, reservation: this.localReservation}).then(response => {
                if (response == 'invalid') {
                    return false;
                }

                if (response.status == 200) {
                    this.$toasted.success('Reservation created successfully');
                    this.$router.push({ name: 'reservations' });

                    this.addFloatingNotification(
                        {
                            type: -1,
                            title: 'Ticket '+this.formatTicketNumber(response.data.id),
                            message: response.data.customer.name+' <br>'+response.data.event.product.name,
                            bookingId: response.data.id,
                        },
                        'info',
                        {
                            link: '/reservations/view/'+response.data.id
                        }
                    )

                    if (printTicket) {
                        axios.get('/api/booking/GetTicket', {
                            params: {
                                bookingId: response.data.id
                            }
                        }).then(response => {
                            this.openByteArrayNewTab(response.data)
                        })

                        // Print invoice
                        let referanceToMakeChanges = this.selectedSellerAccessList
                        if (response.data.bookingInvoices.length > 0 && response.data.bookingInvoices[0].id && hasInvoiceSystem) {
                            vm.printInvoice(response.data.bookingInvoices[0].id).then(responsePrintInvoice => {
                                if (responsePrintInvoice.status == 200) {
                                    vm.openByteArrayNewTab(responsePrintInvoice.data);
                                }
                            }).catch(err => {})
                        }
                    }
                } else {
                    this.clickedSaveAndPrint = false;
                    this.clickedSave = false;
                }

                this.isSaving = false;
            }).catch(error => {
                this.clickedSaveAndPrint = false;
                this.clickedSave = false;
                this.isSaving = false;
            });
        },
        applyDeposit() {
            const amount = this.getReservationCalculations.grandTotalDepositValueRequired
            this.$set(this.localReservation, 'payments', [
                {
                    value: this.getReservationCalculations.grandTotal,
                    currency: "€",
                    treasurerAgent: this.localReservation.creatorAgent,
                    allocations: [{
                        type: -100,
                        amount,
                        change: 0,
                        isAgentPayment: true,
                    }],
                }
            ])
        },
        switchCommissionType(type) {
            // For now comission is always %
            if (this.localReservation.currentChannelCommission[type.toLowerCase() + 'ValueType'] === 0) {
                this.localReservation.currentChannelCommission[type.toLowerCase() + 'ValueType'] = 1;
            } else {
                this.localReservation.currentChannelCommission[type.toLowerCase() + 'ValueType'] = 0;
            }
        },
        editingCommissionToogle(type) {
            this.$set(this.isEditingCommissions, type.toLowerCase(), !this.isEditingCommissions[type.toLowerCase()]);
            this.localReservation.currentChannelCommission['isToOverwrite' + type] = true;
        },
        overrideCommissionChanged(e, type) {
            //type can be: product, component, transport
            if (e.data == null) {
                this.localReservation.currentChannelCommission[type.toLowerCase() + 'Value'] = null;
            }

            this.localReservation.currentChannelCommission['IsToOverwrite' + type] = true;
        },
        updateCommissions(commissionType) {
            this.isEditingCommissions[commissionType.type.toLowerCase()] = false;
            this.validateCommissions();
        },
        validateCommissions() {
            const commission = this.reservation.currentChannelCommission;
            const grandTotal = this.getReservationCalculations.grandTotal;
            let hasError = false;
            
            const validateValue = (value, type, label) => {
                if (type === 0 && value > grandTotal) { // (€)
                    this.$toasted.error(`${label} discount is higher than total, please enter a new value`);
                    hasError = true;
                    return 0;
                }
                if (type === 1 && value > 100) { // (%)
                    this.$toasted.error(`${label} discount is higher than 100%, please enter a new value`);
                    hasError = true;
                    return 0;
                }

                return value;
            };
            
            commission.componentValue = validateValue(commission.componentValue, commission.componentValueType, 'Component');
            commission.productValue = validateValue(commission.productValue, commission.productValueType, 'Product');

            if (!hasError) {
                this.refreshCalculations().then(response => {
                    this.localReservation.currentChannelCommission = response.data.currentChannelCommission
                });
            }
        },
        refreshCalculations() {
            return this.setReservationCalculations(this.localReservation);
        }
    },
    components: {
        Loader
    }
}
</script>

<style lang="scss">
    @import '../../../../../assets/scss/_variables.scss';
    
    button.disabled {
        cursor: not-allowed;
        background-color: $light !important;
    }
</style>



// WEBPACK FOOTER //
// TotalAndPay.vue?5506f2ea